import * as types from './types';

export const setCandidateProfileLoading = (isLoading = false) => ({
  type: types.ADMIN_USERS_CANDIDATE_SET_PROFILE_LOADING,
  isLoading
});

export const getFullCandidateProfile = candidateId => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_GET_FULL_PROFILE,
  candidateId
});

export const setCandidateProfileBiagraphicalInfo = biographicalInfo => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION,
  biographicalInfo
});

export const setCandidateProfileHealth = health => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_HEALTH,
  health
});

export const setCandidateProfileLanguages = languages => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_LANGUAGES,
  languages
});

export const setCandidateProfileHousingPreferences = housingPreferences => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES,
  housingPreferences
});

export const setCandidateProfileSecondarySchools = secondarySchools => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS,
  secondarySchools
});


export const setCandidateProfileTeachingExperience = teachingExperience => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE,
  teachingExperience
});


export const setCandidateProfileSportsActivities = sportsActivities => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_SPORTS_ACTIVITIES,
  sportsActivities
});


export const setCandidateProfileContactInfo = contactInfo => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_CONTACT_INFORMATION,
  contactInfo
});


export const setCandidateProfileTeachingCredencials = teachingCredentials => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS,
  teachingCredentials
});


export const setCandidateProfilePersonal = personal => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_PERSONAL,
  personal
});


export const setCandidateProfileUniversitiesColleges = universitiesColleges => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES,
  universitiesColleges
});

export const setPrintVersionIsLoading = (printVersionIsLoading) => ({
  type: types.ADMIN_USERS_CANDIDATE_PROFILE_PRINT_VERSION_IS_LOADING,
  printVersionIsLoading
});

export const printCandidateProfile = (candidateId) => ({
  type: types.ADMIN_USERS_PRINT_CANDIDATE_PROFILE,
  candidateId
});


// WEBPACK FOOTER //
// ./src/actions/admin/users/candidates/index.js